import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * Sets errors for a single app.
 */
export var setAppErrors = function setAppErrors(_ref) {
  var errors = _ref.errors,
    appId = _ref.appId;
  return function (_ref2) {
    var _getState$appsErrors;
    var setState = _ref2.setState,
      getState = _ref2.getState;
    var previousState = (_getState$appsErrors = getState().appsErrors) !== null && _getState$appsErrors !== void 0 ? _getState$appsErrors : {};
    setState({
      appsErrors: _objectSpread(_objectSpread({}, previousState), {}, _defineProperty({}, appId, errors))
    });
  };
};

/**
 * Adds errors to the existing errors for mulitple apps.
 * It merges the errors for each appId with the existing ones.
 */
export var addAppsErrors = function addAppsErrors(_ref3) {
  var errors = _ref3.errors;
  return function (_ref4) {
    var _getState$appsErrors2;
    var setState = _ref4.setState,
      getState = _ref4.getState;
    var previousState = (_getState$appsErrors2 = getState().appsErrors) !== null && _getState$appsErrors2 !== void 0 ? _getState$appsErrors2 : {};
    var appsErrors = Object.entries(errors).reduce(function (acc, _ref5) {
      var _acc$appId;
      var _ref6 = _slicedToArray(_ref5, 2),
        appId = _ref6[0],
        appErrors = _ref6[1];
      acc[appId] = [].concat(_toConsumableArray((_acc$appId = acc[appId]) !== null && _acc$appId !== void 0 ? _acc$appId : []), _toConsumableArray(appErrors));
      return acc;
    }, _objectSpread({}, previousState));
    setState({
      appsErrors: appsErrors
    });
  };
};
export var resetAppErrors = function resetAppErrors(_ref7) {
  var appId = _ref7.appId;
  return function (_ref8) {
    var _getState$appsErrors3;
    var setState = _ref8.setState,
      getState = _ref8.getState;
    var previousState = (_getState$appsErrors3 = getState().appsErrors) !== null && _getState$appsErrors3 !== void 0 ? _getState$appsErrors3 : {};
    setState({
      appsErrors: _objectSpread(_objectSpread({}, previousState), {}, _defineProperty({}, appId, null))
    });
  };
};